import React from 'react'
import { Section, YouTubeVideo } from 'newComponents'
import './styles.scss'

const YoutubeVideo = (props) => {
  const { data } = props
  const { primary } = data
  const { youtube_id: videoId } = primary

  const hasVideo = videoId && videoId.text

  if (!hasVideo) return null

  return (
    <Section className="youtube-video-slice">
      <YouTubeVideo videoId={hasVideo} noAutoPlay />
    </Section>
  )
}

export default YoutubeVideo
